module.exports = __webpack_public_path__ + "media/images/default-avatar-04e428235c4c386e169acd092072728b.png";